const mutations = {
  HIDE_AUTH_DIALOG: (state) => {
    state.login = false;
  },

  SHOW_AUTH_DIALOG: (state) => {
    state.login = true;
  },

  WIPE_CONTEXTS: state => {
    state.context = null
    state.contexts = {}
  },
  
  SAVE_CONTEXT: async (state, auth) => {
    state.contexts = {...state.contexts, ...{[auth.context]: auth.payload}}
  },

  SWITCH_CONTEXT: async (state, id) => {
    state.context = id
  },

  SET_TOKEN: (state, data) => {
    let myContextSlug = state.contexts[data.context];
    myContextSlug.token = data.token;
    state.contexts = {...state.contexts, ...myContextSlug}
  },

}

export default mutations